import apiClient from './axios';
import type { Role, RoleInput, ListQueryInput, PaginatedListResponse } from '@cms/models';

export type RolesListParams = ListQueryInput & { status?: string };
export type RolesListResponse = PaginatedListResponse<Role>;

export const roleApi = {
  getAll: async (params?: { isSystem?: boolean; select?: string }): Promise<Role[]> => {
    const response = await apiClient.get<Role[]>(`/auth/roles`, { params });
    return response.data;
  },

  getPaginated: async (params: RolesListParams = {}): Promise<RolesListResponse> => {
    const { page = 1, pageSize = 25, search, status, sortBy, sortOrder } = params;
    const response = await apiClient.get<RolesListResponse>('/auth/roles', {
      params: {
        page,
        pageSize,
        ...(search ? { search } : {}),
        ...(status ? { status } : {}),
        ...(sortBy ? { sortBy } : {}),
        ...(sortOrder ? { sortOrder } : {}),
      },
    });
    return response.data;
  },

  getById: async (id: string): Promise<Role> => {
    const response = await apiClient.get<Role>(`/auth/roles/${id}`);
    return response.data;
  },

  create: async (data: RoleInput): Promise<Role> => {
    const response = await apiClient.post<Role>(`/auth/roles`, data);
    return response.data;
  },

  update: async (id: string, data: Partial<RoleInput>): Promise<Role> => {
    const response = await apiClient.patch<Role>(`/auth/roles/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/auth/roles/${id}`);
  },
};
